<template>
  <section
    id="chatMessages"
    :class="[isAdmin ? 'chat-wrapper' : 'custom-chat-messages']"
    @mousedown="setFocusMessage"
  >
    <div id="chatMessagesheader" class="row custom-row custom-header" v-if="!isAdmin">
      <div class="col-md-1">
        <div
          class="custom-members"
          :class="{ 'custom-members-show': isShowMembers }"
          title="channel members"
          @click="showMembers"
        >
          <i class="fas fa-users"></i>
        </div>
      </div>
      <div class="col-md-10 custom-message-title">
        <div class="custom-title">{{ title }}</div>
        <div class="custom-subtitle">{{ subtitle }}</div>
        <div class="custom-footertitle">{{ footertitle }}</div>
      </div>
      <div class="col-md-1 custom-actions">
        <div
          v-if="isCenter || isDispatch"
          title="drop to chat bar"
          class="custom-minimize"
          @click="minimizeMessages"
        >
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="custom-close" title="close" @click="closeMessages">
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>
    <div class="row custom-row">
      <div v-if="isShowMembers" class="custom-member-panel">
        <ul>
          <li v-for="(member, idx) in members" :key="idx">
            <span
              >{{ member.name }} <span class="custom-email">({{ member.email }})</span></span
            >
          </li>
        </ul>
      </div>
      <div class="col-md-12 md chat-page-content messages-content">
        <div v-if="$loading.isLoading('getChatMessages')" class="messages custom-spinner">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
        <div class="messages" id="chatMessages" v-else>
          <div
            v-for="(item, idx) in messages"
            :key="idx"
            class="message"
            :class="setMessageClass(item, idx)"
          >
            <div class="message-content">
              <div class="message-name">{{ item.name }}</div>
              <div class="message-bubble" :style="`backgroundColor: ${item.color};`">
                <div class="message-text">
                  <span v-html="item.message"></span>
                </div>
                <div class="message-text-footer custom-message-footer">
                  {{ item.createdOn }}
                </div>
                <div
                  v-if="isMemberName(item, idx)"
                  class="message-text-footer custom-message-footer"
                >
                  {{ item.member }}
                </div>
              </div>
            </div>
          </div>
          <div class="custom-typing">
            <span>{{ whosTyping }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row custom-message-bar" v-if="!isAdmin">
      <div class="col-md-12 toolbar messagebar">
        <div class="messagebar-area">
          <textarea
            v-model="newMessage"
            ref="newMessage"
            placeholder="type message..."
            class="custom-message"
            @keyup="userTyping"
          ></textarea>
          <div class="custom-emoji" @click="toggleEmoji">
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
              />
            </svg>
          </div>
        </div>
        <a href="#" class="link" title="send message" @click="processMessage">
          <i class="fas fa-arrow-circle-up"></i>
        </a>
      </div>
    </div>
    <emoji-widget ref="emojiWidget" @emoji="appendEmoji" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import EmojiWidget from './emoji/emoji-widget'
import globals from '@/plugins/globals'
export default {
  name: 'chat',
  components: {
    EmojiWidget
  },
  props: {
    channelId: [String, Number],
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      typingMessage: null,
      placeholder: 'type message...',
      newMessage: '',
      search: '',
      waitTimeout: null,
      waitTypingTimeout: null,
      isShowMembers: false,
      isTyping: false,
      whosTyping: null
    }
  },
  mounted() {
    this.isShowMembers = false
    globals.dragElement(document.getElementById('chatMessages'))
    this.$eventBus.$on('chat-user-typing', this.someoneTyping)
    this.setFocusMessage()
  },
  watch: {
    messages() {
      this.showLastMessage()
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('chat', ['channelInfo', 'messages']),
    ...mapGetters('calibrates', ['calibrateEvent']),
    isShop() {
      let _is = false
      if (this.profile.roles[0] === 4 || this.profile.roles[0] === 5) {
        _is = true
      }
      return _is
    },
    isCenter() {
      let _is = false
      if (this.profile.roles[0] === 8 || this.profile.roles[0] === 9) {
        _is = true
      }
      return _is
    },
    isDispatch() {
      let _is = false
      if (this.profile.roles[0] === 12 || this.profile.roles[0] === 13) {
        _is = true
      }
      return _is
    },
    title() {
      let _title = 'Chat'
      if (this.channelInfo) {
        _title = `# ${this.channelInfo.id} - RO ${this.channelInfo.ronumber}`
      }
      return _title
    },
    subtitle() {
      let _subtitle = ''
      if (this.channelInfo) {
        _subtitle = this.channelInfo.vehicleInfo
      }
      return _subtitle
    },
    footertitle() {
      let _footer = ''
      if (this.channelInfo && !this.isShop) {
        _footer = this.channelInfo.firmName
      }
      return _footer
    },
    members() {
      let _data = null
      if (this.channelInfo) {
        _data = this.channelInfo.members
      }
      return _data
    }
  },
  methods: {
    ...mapActions('chat', ['sendMessage', 'memberTyping']),
    toggleEmoji() {
      this.$refs.emojiWidget.toggle()
    },
    appendEmoji(emoji) {
      this.newMessage += emoji
    },
    setFocusMessage() {
      if (this.$refs.newMessage) {
        this.$refs.newMessage.focus()
      }
    },
    setMessageClass(msg, idx) {
      let previousMessage = this.messages[idx - 1]
      let nextMessage = this.messages[idx + 1]
      let _class = ''
      if (msg.type === 'sent') {
        _class = 'message-received'
      } else {
        _class = 'message-sent'
      }
      if (
        !previousMessage ||
        previousMessage.type !== msg.type ||
        previousMessage.name !== msg.name
      ) {
        _class += ' message-first'
      }
      if (!nextMessage || nextMessage.type !== msg.type || nextMessage.member !== msg.member) {
        _class += ' message-last message-tail'
      }
      return _class
    },
    isMemberName(msg, idx) {
      let is = false
      let nextMessage = this.messages[idx + 1]
      if (!nextMessage || nextMessage.type !== msg.type || nextMessage.member !== msg.member) {
        is = true
      }
      return is
    },
    showLastMessage() {
      let $this = this
      setTimeout(function() {
        var elements = $this.$el.getElementsByClassName('message')
        if (elements.length) {
          elements[elements.length - 1].scrollIntoView()
        }
      }, 500)
    },
    processMessage() {
      let data = {
        type: 5,
        contentType: 0,
        message: this.newMessage,
        channelId: this.channelId,
        metadata: {},
        source: 6
      }
      console.log('Sending Message', data)
      this.sendMessage(data)
      this.$refs.newMessage.focus()
      this.showLastMessage()
      if (this.calibrateEvent) {
        if (this.calibrateEvent.members) {
          if (this.calibrateEvent.members.length > 0) {
            let tokens = ''
            this.calibrateEvent.members.forEach(element => {
              if (tokens !== '') {
                tokens += ','
              }
              tokens += element.FirebaseToken
            })
            if (tokens !== '') {
              data = {
                id: this.profile.firm,
                type: 'Chat',
                event: 'Message',
                source: tokens,
                target: this.channelId,
                message: this.newMessage
              }
              this.$eventBus.$emit('push-message', data)
            }
          }
        }
      }
      this.newMessage = ''
    },
    showMembers() {
      console.log('Show Members', this.channelInfo)
      this.isShowMembers = !this.isShowMembers
    },
    closeMessages() {
      this.$emit('closeMessages')
    },
    minimizeMessages() {
      this.$emit('minimizeMessages')
    },
    someoneTyping(data) {
      this.isTyping = false
      this.whosTyping = null
      if (data.guid !== this.profile.guid) {
        if (data.message === 'typing_on' && parseInt(data.channel) === parseInt(this.channelId)) {
          console.log('Another member typing', data)
          this.whosTyping = `${data.member} is typing...`
          this.isTyping = true
        }
      }
    },
    userTyping(e) {
      let $this = this
      window.clearTimeout(this.waitTimeout)
      window.clearTimeout(this.waitTypingTimeout)
      let data = {
        channel: this.channelId,
        status: 'typing_on'
      }
      this.waitTypingTimeout = window.setTimeout(() => {
        $this.memberTyping(data)
      }, 250)
      this.waitTimeout = window.setTimeout(() => {
        data.status = 'typing_off'
        $this.memberTyping(data)
      }, 1500)
      if (e.keyCode === 13) {
        if (e.ctrlKey) {
          this.message += '\n'
        } else {
          e.preventDefault()
          this.processMessage()
        }
      }
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      }
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('chat-user-typing')
  }
}
</script>
<style lang="scss" scoped>
.chat-wrapper {
  width: 100%;
}
.custom-chat-messages {
  overflow: hidden;
  border: 1px solid #c8c8cd;
  padding-top: 2px;
  background-color: #98d9f7;
}
.custom-message-title {
  text-align: left;
  font-weight: 600;
  font-size: 1.1em;
  margin: 0;
  line-height: 1em;
}
.custom-title {
  width: 100%;
  margin: 0;
  padding: 0;
  position: relative;
}
.custom-subtitle {
  margin: 0;
  padding: 0;
  width: 100%;
  font-size: 0.8em;
  position: relative;
}
.custom-footertitle {
  margin: 0;
  padding: 0;
  width: 100%;
  font-size: 0.8em;
  position: relative;
}
.custom-message {
  // height: 60px;
  resize: vertical;
  overflow: auto;
}
.custom-actions {
  display: inline-flex;
  position: relative;
  margin: 0;
  padding: 0;
}
.custom-close {
  cursor: pointer;
  position: absolute;
  top: 2px;
  right: 8px;
}
.custom-minimize {
  cursor: pointer;
  position: absolute;
  top: 2px;
  left: -12px;
}
.custom-row {
  position: relative;
  margin-left: 2px;
  margin-right: 2px;
  border-bottom: 1px solid #c8c8cd;
}
.custom-spinner {
  width: 100%;
  text-align: center;
  font-size: 1.2em;
  font-weight: 500;
  height: 40px;
}
.custom-header {
  height: 56px;
  cursor: move;
}
.custom-members {
  position: absolute;
  left: 5px;
  cursor: pointer;
  margin: 1px;
  padding: 2px;
  border-radius: 2px;
}
.custom-member-panel {
  background-color: #98d9f7;
  width: 300px;
  height: 180px;
  overflow-x: hidden;
  overflow-y: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
}
.custom-members-show {
  // border: 1px solid;
  background-color: rgba($color: #ffffff, $alpha: 0.7);
}
.custom-email {
  font-size: 0.8em;
}
.custom-message-bar {
  position: relative;
  overflow: auto;
}
.custom-typing {
  position: absolute;
  bottom: 0px;
  font-size: 0.7em;
  z-index: 10;
  left: 0;
}

.custom-emoji {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  :hover {
    transform: scale(1.1);
  }
  svg {
    fill: #888888;
  }
  position: absolute;
  z-index: 10;
  right: 5px;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/chat-messages.vue